import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Card } from '../elements';
import { Tree, TreeNode } from 'react-organizational-chart';
import { CONSTS } from '../elements/_constants';
import { fetchCharts, getChart } from '../../store/charts/functions';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import { Chart } from '../../store/charts/types';
import { withRouter } from 'react-router';
type NodeProps = {
    className? :string,
    children?: any,
    title :string,
    meta? :string
}
const Node = (props :NodeProps) => (
    <div className={props.className}>
        <h3 className="_title">{props.title}</h3>
        <div className="_meta">{props.meta}</div>
    </div>
)
const StyledNode = styled(Node)`
  padding: 5px 10px;
  border-radius: 8px;
  display: inline-block;
  border: 1px solid ${CONSTS.colors.greyDark};
  > ._title{
      color: ${CONSTS.colors.primary};
      font-size: 11px;
      font-weight: 500;
      margin:0;
  }
  > ._meta{
    font-size: 11px;
    font-weight: normal;
    color: #333;
  }
`;

type HieararchyComponentProps = {
    className?: string,
    match: any,
    currentPathName: string
    loadCharts: Function,
    charts : Chart[]
}
const HieararchyComponent = (props :HieararchyComponentProps) => {
    props.loadCharts();

    const chart = getChart(props.charts, parseInt(props.match.params.id));
    console.log(chart);
    const printNode = (node:any) =>{
        if (node.children.length > 0){
            return (
                <TreeNode label={<StyledNode title={node.title} meta={node.description}/>}>
                    {
                        node.children.map((child:any) => printNode(child))
                    }
                </TreeNode>
            )
        }
        else{
            return (
                <TreeNode label={<StyledNode title={node.title} meta={node.description}/>} />
            )
        }
    }

    if(chart)
        return(
            <Card className={props.className} title={chart.title}>
                <div className="_body" style={{padding: 15}}>
                    {chart.nodes.length>0 &&
                        <Tree lineWidth="1px" label={<StyledNode title={chart.nodes[0].title} meta={chart.nodes[0].description}/>} lineColor={CONSTS.colors.greyDark} lineHeight="20px" lineBorderRadius={CONSTS.border.radius} nodePadding="0">
                            {
                                chart.nodes[0].children.map( (node :any) => printNode(node))
                            }
                        </Tree>
                    }
                </div>
            </Card>
        )
    else return (<div></div>)
}
const Hieararchy = styled(HieararchyComponent)`
    margin-left: 20px;
    ._body{
        direction: ltr;
        text-align: left;
    }
`
const mapStateToProps = (state: AppState) => ({
    charts : state.charts.items,
    currentPathName: state.base.path
})
const mapDispatchToProps = (dispatch :Function, getState :Function) => ({
    loadCharts: () => {
        dispatch(fetchCharts())
    }
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Hieararchy);